import { render, staticRenderFns } from "./editSubscriber.vue?vue&type=template&id=58e37df5&scoped=true"
import script from "./editSubscriber.vue?vue&type=script&lang=js"
export * from "./editSubscriber.vue?vue&type=script&lang=js"
import style0 from "./editSubscriber.vue?vue&type=style&index=0&id=58e37df5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e37df5",
  null
  
)

export default component.exports